import { sha256 } from "@noble/hashes/sha2.js";

/** HTTP IP 预览没有 Web Crypto，仍使用 SHA-256 校验，不能跳过媒体版本验证。 */
export async function mediaSha256(data: ArrayBuffer): Promise<string> {
  const bytes = globalThis.crypto?.subtle
    ? new Uint8Array(await crypto.subtle.digest("SHA-256", data))
    : sha256(new Uint8Array(data));
  return [...bytes].map(byte => byte.toString(16).padStart(2, "0")).join("");
}
